import React, { useState, useRef, useEffect } from "react";
import axios from 'axios';
import "../../../css/dashboard.css";
import { useNavigate, useLocation } from "react-router-dom";
import styled from "styled-components";

function CostDetail(props) {

    const location = useLocation();
    const navigate = useNavigate();
    const [price, setPrice] = useState({});
    const modalRef = useRef();

    const getPriceDetail = async () => {
        try {
            const reserve_result = await axios.get(`/PriceIdx/${location.state.idx}`);
            setPrice(reserve_result.data[0]);
        } catch (error) {
            console.error('Error fetching reservation count:', error.message);
        }
    };

    const startBeforePage = () => {
        if (location.state && location.state.beforePage) {
            navigate(location.state.beforePage);
        } else {
            navigate(-1);
        }
    }

    const startModal = () => {
        modalRef.current.showModal();
    }

    // Change Handlers (코드가 길어지는 것을 방지하기 위해 통합 핸들러 사용 가능하지만, 기존 구조 유지)
    const ChangeKind = (e) => setPrice({ ...price, kind: e.target.value });
    const ChangeBasePrice = (e) => setPrice({ ...price, base_price: e.target.value });
    const ChangeAddPrice = (e) => setPrice({ ...price, add_price: e.target.value });
    const ChangeHeight = (e) => setPrice({ ...price, height: e.target.value });
    const ChangeHeating = (e) => setPrice({ ...price, heating: e.target.value });
    const ChangeClearing = (e) => setPrice({ ...price, clearing: e.target.value });
    const ChangeLift = (e) => setPrice({ ...price, lift: e.target.value });
    const ChangeAmount1 = (e) => setPrice({ ...price, sale_amount_1: e.target.value });
    const ChangePercent1 = (e) => setPrice({ ...price, sale_percent_1: e.target.value });
    const ChangeAmount2 = (e) => setPrice({ ...price, sale_amount_2: e.target.value });
    const ChangePercent2 = (e) => setPrice({ ...price, sale_percent_2: e.target.value });
    const ChangeAmount3 = (e) => setPrice({ ...price, sale_amount_3: e.target.value });
    const ChangePercent3 = (e) => setPrice({ ...price, sale_percent_3: e.target.value });

    const putPriceInfo = async () => {
        const requestData = { ...price }; // 전체 state 전송 (필드명 일치 가정)
        try {
            const put_result = await axios.put(`/PriceInfo/${location.state.idx}`, requestData);
            if (put_result.data.success === true) {
                alert('수정이 완료되었습니다');
                modalRef.current.close();
            } else {
                alert('수정에 실패하였습니다');
            }
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        getPriceDetail();
    }, [location.state.idx]);

    return (
        <PageContainer>
            <Card>
                <CardHeader>
                    <Title>요금 상세 정보</Title>
                </CardHeader>

                <SectionTitle>기본 요금 정보</SectionTitle>
                <GridContainer>
                    <InfoItem label="작업 종류" value={price.kind} span={2} />
                    <InfoItem label="기본 단가" value={price.base_price} isHighlight />
                    <InfoItem label="시간외 수당" value={price.add_price} />
                </GridContainer>

                <SectionTitle>추가 요금 옵션</SectionTitle>
                <GridContainer>
                    <InfoItem label="천정고 (3m 이상)" value={price.height} />
                    <InfoItem label="냉난방" value={price.heating} />
                    <InfoItem label="공기청정" value={price.clearing} />
                    <InfoItem label="리프트" value={price.lift} />
                </GridContainer>

                <SectionTitle>할인 정책</SectionTitle>
                <DiscountGrid>
                    <DiscountCard>
                        <DiscountLabel>할인 정보 1</DiscountLabel>
                        <DiscountValue>{price.sale_amount_1}대 이상</DiscountValue>
                        <DiscountPercent>{price.sale_percent_1}% 할인</DiscountPercent>
                    </DiscountCard>
                    <DiscountCard>
                        <DiscountLabel>할인 정보 2</DiscountLabel>
                        <DiscountValue>{price.sale_amount_2}대 이상</DiscountValue>
                        <DiscountPercent>{price.sale_percent_2}% 할인</DiscountPercent>
                    </DiscountCard>
                    <DiscountCard>
                        <DiscountLabel>할인 정보 3</DiscountLabel>
                        <DiscountValue>{price.sale_amount_3}대 이상</DiscountValue>
                        <DiscountPercent>{price.sale_percent_3}% 할인</DiscountPercent>
                    </DiscountCard>
                </DiscountGrid>

                <ButtonGroup>
                    <OutlineButton onClick={startBeforePage}>목록으로</OutlineButton>
                    <PrimaryButton onClick={startModal}>수정하기</PrimaryButton>
                </ButtonGroup>
            </Card>

            {/* 수정 모달 */}
            <StyledDialog ref={modalRef}>
                <DialogHeader>
                    <h3>요금 정보 수정</h3>
                    <CloseButton onClick={() => modalRef.current.close()}>&times;</CloseButton>
                </DialogHeader>
                <DialogContent>
                    <SectionTitle>기본 설정</SectionTitle>
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px', marginBottom: '20px' }}>
                        <InputGroup label="작업종류" value={price.kind} onChange={ChangeKind} />
                        <InputGroup label="단가" value={price.base_price} onChange={ChangeBasePrice} />
                        <InputGroup label="시간외수당" value={price.add_price} onChange={ChangeAddPrice} />
                        <InputGroup label="천정고" value={price.height} onChange={ChangeHeight} />
                    </div>

                    <SectionTitle>추가 옵션</SectionTitle>
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '15px', marginBottom: '20px' }}>
                        <InputGroup label="냉난방" value={price.heating} onChange={ChangeHeating} />
                        <InputGroup label="공기청정" value={price.clearing} onChange={ChangeClearing} />
                        <InputGroup label="리프트" value={price.lift} onChange={ChangeLift} />
                    </div>

                    <SectionTitle>할인 기준</SectionTitle>
                    <DiscountInputRow>
                        <Label>기준 1</Label>
                        <StyledInput style={{ width: '80px' }} value={price.sale_amount_1} onChange={ChangeAmount1} />
                        <span>대 이상</span>
                        <StyledInput style={{ width: '80px' }} value={price.sale_percent_1} onChange={ChangePercent1} />
                        <span>%</span>
                    </DiscountInputRow>
                    <DiscountInputRow>
                        <Label>기준 2</Label>
                        <StyledInput style={{ width: '80px' }} value={price.sale_amount_2} onChange={ChangeAmount2} />
                        <span>대 이상</span>
                        <StyledInput style={{ width: '80px' }} value={price.sale_percent_2} onChange={ChangePercent2} />
                        <span>%</span>
                    </DiscountInputRow>
                    <DiscountInputRow>
                        <Label>기준 3</Label>
                        <StyledInput style={{ width: '80px' }} value={price.sale_amount_3} onChange={ChangeAmount3} />
                        <span>대 이상</span>
                        <StyledInput style={{ width: '80px' }} value={price.sale_percent_3} onChange={ChangePercent3} />
                        <span>%</span>
                    </DiscountInputRow>

                </DialogContent>
                <DialogActions>
                    <OutlineButton onClick={() => modalRef.current.close()}>취소</OutlineButton>
                    <PrimaryButton onClick={putPriceInfo}>저장하기</PrimaryButton>
                </DialogActions>
            </StyledDialog>
        </PageContainer>
    )
}

// --- Helper Components ---
const InfoItem = ({ label, value, span = 1, isHighlight }) => (
    <div style={{ gridColumn: `span ${span}`, display: 'flex', flexDirection: 'column', gap: '2px' }}>
        <Label>{label}</Label>
        <Value isHighlight={isHighlight}>{value || '-'}</Value>
    </div>
);

const InputGroup = ({ label, value, onChange }) => (
    <div>
        <Label>{label}</Label>
        <StyledInput value={value || ''} onChange={onChange} />
    </div>
);

// --- Styled Components (80% Compact) ---

const PageContainer = styled.div`
    padding: 20px;
    background-color: #f5f6f8;
    min-height: 100vh;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    padding-top: 40px;
    box-sizing: border-box;
`;

const Card = styled.div`
    background: white;
    width: 100%;
    max-width: 900px; // 요금 정보는 너비가 넓을 필요 없음
    border-radius: 16px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
    padding: 32px 36px;
    display: flex;
    flex-direction: column;
    gap: 20px;
`;

const CardHeader = styled.div`
    border-bottom: 1px solid #eee;
    padding-bottom: 12px;
    margin-bottom: 8px;
`;

const Title = styled.h2`
    font-size: 1.5rem;
    color: #111;
    margin: 0;
    font-weight: 800;
`;

const SectionTitle = styled.h3`
    font-size: 1.1rem;
    color: #333;
    margin: 0 0 10px 0;
    border-left: 4px solid #006edc;
    padding-left: 10px;
`;

const GridContainer = styled.div`
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    column-gap: 20px;
    row-gap: 16px;
    @media (max-width: 768px) { grid-template-columns: repeat(2, 1fr); }
`;

const Label = styled.div`
    font-size: 0.8rem;
    color: #888;
    font-weight: 500;
    margin-bottom: 3px;
`;

const Value = styled.div`
    font-size: 0.95rem;
    color: ${props => props.isHighlight ? '#d32f2f' : '#222'};
    font-weight: ${props => props.isHighlight ? 'bold' : 'normal'};
    border-bottom: 1px solid #f0f0f0;
    padding-bottom: 5px;
    min-height: 22px;
    word-break: break-all;
`;

// Discount Styles
const DiscountGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 15px;
    @media (max-width: 600px) { grid-template-columns: 1fr; }
`;

const DiscountCard = styled.div`
    background-color: #f8f9fa;
    border: 1px solid #e9ecef;
    border-radius: 8px;
    padding: 15px;
    text-align: center;
`;

const DiscountLabel = styled.div`
    font-size: 0.85rem;
    color: #666;
    margin-bottom: 5px;
`;

const DiscountValue = styled.div`
    font-size: 1rem;
    font-weight: bold;
    color: #333;
    margin-bottom: 2px;
`;

const DiscountPercent = styled.div`
    font-size: 1.1rem;
    font-weight: 800;
    color: #d32f2f; // 빨간색 강조
`;

const DiscountInputRow = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 10px;
    span { font-size: 0.9rem; color: #555; }
    ${Label} { margin-bottom: 0; width: 60px; }
`;

const ButtonGroup = styled.div`
    display: flex;
    justify-content: flex-end;
    gap: 10px;
    margin-top: 20px;
    padding-top: 20px;
    border-top: 1px solid #eee;
`;

const BaseButton = styled.button`
    padding: 8px 18px;
    border-radius: 8px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s;
    border: none;
    font-size: 0.9rem;
`;

const PrimaryButton = styled(BaseButton)`
    background-color: #006edc;
    color: white;
    &:hover { background-color: #0056b3; }
`;

const OutlineButton = styled(BaseButton)`
    background-color: white;
    border: 1px solid #ccc;
    color: #555;
    &:hover { background-color: #f9f9f9; border-color: #bbb; }
`;

const StyledInput = styled.input`
    width: 100%;
    padding: 8px 10px;
    border: 1px solid #ddd;
    border-radius: 6px;
    font-size: 0.95rem;
    box-sizing: border-box;
    &:focus { border-color: #006edc; outline: none; }
`;

// --- Modal Styles ---
const StyledDialog = styled.dialog`
    border: none;
    border-radius: 16px;
    padding: 0;
    width: 90%;
    max-width: 700px;
    box-shadow: 0 10px 40px rgba(0,0,0,0.25);
    &::backdrop { background: rgba(0, 0, 0, 0.6); }
`;

const DialogHeader = styled.div`
    padding: 16px 20px;
    border-bottom: 1px solid #eee;
    display: flex;
    justify-content: space-between;
    align-items: center;
    h3 { margin: 0; font-size: 1.2rem; font-weight: 700; }
`;

const DialogContent = styled.div`
    padding: 24px;
    background: #fff;
    max-height: 80vh;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
`;

const DialogActions = styled.div`
    padding: 16px 20px;
    border-top: 1px solid #eee;
    display: flex;
    justify-content: flex-end;
    gap: 10px;
`;

const CloseButton = styled.button`
    background: none; border: none; font-size: 1.8rem; cursor: pointer; color: #999; line-height: 1;
    &:hover { color: #333; }
`;

export default CostDetail;